import entitiesSelector from './entities_selector';

const cohortsSelector = entitiesSelector(
  state => state.cohorts,
  (cohort, localState, associations) => {
    const first_name = cohort.first_name || cohort.id;
    const last_name = cohort.last_name || '';
    return { name: `${first_name} ${last_name}` };
  }
);

export default cohortsSelector;


/** WEBPACK FOOTER **
 ** ./src/js/selectors/cohorts_selector.js
 **/